import { render, staticRenderFns } from "./TosPassword.vue?vue&type=template&id=50a921d0&scoped=true"
import script from "./TosPassword.vue?vue&type=script&lang=js"
export * from "./TosPassword.vue?vue&type=script&lang=js"
import style0 from "./TosPassword.vue?vue&type=style&index=0&id=50a921d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a921d0",
  null
  
)

export default component.exports